import { render, staticRenderFns } from "./chatComponent2.vue?vue&type=template&id=3cbfe860&scoped=true&"
import script from "./chatComponent2.vue?vue&type=script&lang=js&"
export * from "./chatComponent2.vue?vue&type=script&lang=js&"
import style0 from "./chatComponent2.vue?vue&type=style&index=0&id=3cbfe860&prod&lang=less&scoped=true&"
import style1 from "./chatComponent2.vue?vue&type=style&index=1&id=3cbfe860&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfe860",
  null
  
)

export default component.exports